import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Star } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "María González",
    role: "CEO, Boutique Fashion",
    content:
      "Producciones Palacios transformó nuestra presencia digital. El contenido que crean realmente conecta con nuestra audiencia. Nuestro engagement aumentó un 200%.",
    rating: 5,
  },
  {
    id: 2,
    name: "Carlos Mendoza",
    role: "Director, Tech Startup",
    content:
      "El diseño web superó todas nuestras expectativas. Moderno, funcional y que realmente convierte. El mejor equipo creativo con el que hemos trabajado.",
    rating: 5,
  },
  {
    id: 3,
    name: "Ana Rodríguez",
    role: "Fundadora, E-commerce Beauty",
    content:
      "La estrategia de marketing nos ayudó a triplicar ventas en 6 meses. Profesionales, creativos y siempre disponibles. ¡100% recomendados!",
    rating: 5,
  },
];

export default function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section
      id="testimonials"
      ref={ref}
      className="py-24 lg:py-32 bg-[#0a0a0a] relative overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Background */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 lg:mb-16"
        >
          <p className="overline mb-4">Testimonios</p>
          <h2 className="font-playfair text-3xl lg:text-5xl font-bold text-white mb-6">
            Lo que dicen{" "}
            <span className="italic text-[#FF6B6B]">nuestros clientes</span>
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : {}}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="bg-[#121212] border border-white/10 rounded-lg p-6 lg:p-8"
              data-testid={`testimonial-${testimonial.id}`}
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className="fill-[#D4AF37] text-[#D4AF37]"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-white/90 leading-relaxed mb-6 text-sm lg:text-base">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#FF6B6B] rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                  <p className="text-[#A3A3A3] text-xs">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
